// extracted by mini-css-extract-plugin
export var circles = "styles-module--circles--c14cf";
export var container = "styles-module--container--88c03";
export var content = "styles-module--content--bab6d";
export var inner = "styles-module--inner--1ed96";
export var primaryCircle1 = "styles-module--primaryCircle1--386f0";
export var primaryCircle2 = "styles-module--primaryCircle2--69a57";
export var primaryCircle3 = "styles-module--primaryCircle3--0b6aa";
export var primaryCircle4 = "styles-module--primaryCircle4--a9745";
export var secondaryCircle1 = "styles-module--secondaryCircle1--1cc53";
export var secondaryCircle2 = "styles-module--secondaryCircle2--981eb";
export var secondaryCircle3 = "styles-module--secondaryCircle3--5685f";
export var secondaryCircle4 = "styles-module--secondaryCircle4--5e4a8";